/*
 * � 2020 Microsoft. All rights reserved.
 */

define('SolitaireShared/CardLogic/BakedInSeeds',['../../Solitaire/MvvmStructure/Service/BakedInSolvablesService'], function (BakedInSolvablesService) {
    var BakedInSeed = function (gameName, options) {
        this.randomBakedSeed;
        this.gameName = gameName.toLowerCase();

        if (this.gameName == 'klondike') {
            var scoring = options.SCORING == 'STANDARD' ? options.SCORING.toLowerCase() : 'lasvegas';                            
            var draw = 'draw' + options.DRAW;
            this.gameName += draw + scoring;
        }

        if (this.gameName == 'spider') {
            var suits = '';
            if (options.SUITS == 1)
                suits = 'onesuit';
            if (options.SUITS == 2)
                suits = 'twosuits';
            if (options.SUITS == 4)
                suits = 'foursuits';

            this.gameName += suits;
        }

        this.difficulty = options.DIFFICULTY.toLowerCase();

        var solvables = BakedInSolvablesService.GetSolvables();
        var gameType = null;

        for (var i = 0; i < solvables.length; i++) {
            if (solvables[i].name == this.gameName && solvables[i].difficulty == this.difficulty) {
                gameType = solvables[i];
                break;
            }
        }

        if (gameType)
            this.randomBakedSeed = gameType.seeds[Math.floor(Math.random() * Math.floor(gameType.seeds.length))].trim();
    };

    return BakedInSeed;
});
